import { Component, OnInit } from '@angular/core';
import { Vehicle } from '../../../models/vehicles/vehicle';
import { TableColumn } from '../../../models/tables/TableColumn';
import { VehicleService } from '../../../services/vehicle.service';
import { ParameterService } from '../../../services/parameter.service';
import { AlertService } from '../../../services/alert.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { PageOption } from '../../../models/common/pageOption';
import { VehicleFilter } from '../../../models/vehicles/vehicleFilter';
import { VehicleColumns } from '../../../contants/columns/columns.vehicle';
import { APP_ROUTES } from '../../../contants/APP_ROUTES';
import { CommonService } from '../../../services/common.service';
import { Helper } from '../../../helpers/Helper';
import { PARAMS } from '../../../contants/PARAMS';

@Component({
	selector: 'app-vehicle-list',
	templateUrl: './vehicle-list.component.html',
	styleUrls: ['./vehicle-list.component.css']
})
export class VehicleListComponent implements OnInit {

	pageOption: PageOption<VehicleFilter> = new PageOption();
	formPath: string = APP_ROUTES.vehicleForm;
	
	vehicles: Vehicle[] = [];
	tableColumns: TableColumn[] = VehicleColumns;
	vehicleEditBackup: Vehicle

	constructor(
		private _vehicleService: VehicleService,
		private _parameterService: ParameterService,
		private _alertService: AlertService,
		private _commonService: CommonService
	) { }

	ngOnInit() {
		this.pageOption.searchFilter = new VehicleFilter();
		this._parameterService.getCachedParameterObject<TableColumn[]>(PARAMS.VEHICLE_TABLE_DEFAULT_COLUMNS, 3600).subscribe(
			value => {
				if (value.length != undefined) {
					this.tableColumns = value.length == 0 ? this.tableColumns : value;
				}
				else {
					this._alertService.showError('Invalid response from server, will use default column settings instead.')
				}
			}
		);

		this._parameterService.getCachedParameter<number>(PARAMS.VEHICLE_TABLE_DEFAULT_PAGE_SIZE, 3600).subscribe(
			value => {
				value = Number(value);
				this.pageOption.pageSize = isNaN(value) || value == 0 ? 50 : value;
				this.pageOption.pageNumber = 1;

				this.fetchData();
			}
		);
	}

	fetchData(){
		this._vehicleService.getVehiclesList(this.pageOption).subscribe(
			result => {
				if (result.data != undefined) {
					if(this.pageOption.pageTotal <= 0){
						this.pageOption.pageTotal = result.totalPages;
					}

					let startIndex = ((result.pageNumber - 1) * this.pageOption.pageSize);
					this._commonService.insertAt(this.vehicles, startIndex, result.data);
				}
			}
		);
	}

	onFetchNextData(pageNumber: number){
		this.pageOption.pageNumber = pageNumber;
		this.fetchData();
	}

	onSave(index: number) {
		let vehicle = this.vehicles[index];
		if (!this.validateVehicle(vehicle)) {
			this.vehicles[index] = this.vehicleEditBackup;
			this._alertService.showError('vehicle should have a plate number with 6-7 chars long.')
			return;
		}

		if (vehicle.id == undefined || vehicle.id == 0) {
			this.createVehicle(vehicle);
		}
		else {
			this.updateVehicle(index, vehicle);
		}
	}

	onAdd(event) {
		this.vehicles.push(new Vehicle());
	}

	onEditBegin(index: number) {
		this.vehicleEditBackup = this._vehicleService.copy(this.vehicles[index]);
	}

	onEditCancel(index: number) {
		if (this.vehicleEditBackup == null) {
			return;
		}
		this.vehicles[index] = this.vehicleEditBackup;
	}

	private createVehicle(newVehicle: Vehicle) {
		this._vehicleService.addVehicle(newVehicle).subscribe(
			result => {
				if (result.object != undefined) {
					this._alertService.showSuccess('Data was saved.')
					this.vehicles[this.vehicles.length - 1] = result.object;
					this.vehicleEditBackup = null;
				}
				else {
					this.vehicles[this.vehicles.length - 1] = new Vehicle();
					this._alertService.displayErrorResult(result.errorCollection);
				}
			}
		);
	}

	private updateVehicle(index: number, existingVehicle: Vehicle) {
		this._vehicleService.updateVehicle(existingVehicle).subscribe(
			result => {
				if (result.object == undefined) {
					this.vehicles[index] = this.vehicleEditBackup;
					this._alertService.displayErrorResult(result.errorCollection);
				}
				else {
					this._alertService.showSuccess('Vehicle data updated.');
					this.vehicleEditBackup = null;
				}
			}
		);
	}

	private validateVehicle(vehicle: Vehicle): boolean {
		let form = new FormGroup({
			plateNumber: new FormControl(vehicle.plateNumber, [
				Validators.required,
				Validators.maxLength(7),
				Validators.minLength(6)
			])
		});

		return form.valid;
	}

	search(filter: VehicleFilter) {
		if(filter != null){
			this.pageOption.searchFilter.plateNumber = Helper.isNullOrUndefined(filter.plateNumber) ? '' : filter.plateNumber;
			this.pageOption.searchFilter.isTruck = filter.isTruck;
		}

		this.vehicles = []; //reset array
		this.fetchData();
	}
}



// WEBPACK FOOTER //
// ./src/app/components/vehicles/vehicle-list/vehicle-list.component.ts